export default function groupBy(list: Array<any>, keyGetter: (i: any) => string) {
    const map: any = {};
    list.forEach((item, index) => {
         const key = keyGetter(item);
         const collection = map[key];
         if (!collection) {
             map[key] = [];
             map[key][index] = item;
         } else {
             collection[index] = item;
         }
    });
    return map;
}